import { render, staticRenderFns } from "./LoginInDemo.vue?vue&type=template&id=118b7b06&scoped=true"
import script from "./LoginInDemo.vue?vue&type=script&lang=js"
export * from "./LoginInDemo.vue?vue&type=script&lang=js"
import style0 from "./LoginInDemo.vue?vue&type=style&index=0&id=118b7b06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118b7b06",
  null
  
)

export default component.exports